@if (lorenzFormControl) {

	<!--	<div class="debug"> | {{ lorenzFormControl.getPath() }} | {{ lorenzFormControl.getKey() }} |</div>-->

	@switch (lorenzFormControl.getControlType()) {

		@case (LorenzControlTypeEnum.CHECKBOX) {
			<lib-form-control-checkbox [control]="lorenzFormControl"
									   [options]="lorenzFormComponentOptions"></lib-form-control-checkbox>
		}
		@case (LorenzControlTypeEnum.DATE) {
			<lib-form-control-datetime [type]="'date'"
									   [control]="lorenzFormControl"
									   [options]="lorenzFormComponentOptions"></lib-form-control-datetime>
		}
		@case (LorenzControlTypeEnum.HTML) {
			<lib-form-control-html [control]="lorenzFormControl"
								   [options]="lorenzFormComponentOptions"></lib-form-control-html>
		}
		@case (LorenzControlTypeEnum.DOCUMENT_UPLOAD) {
			<lib-form-control-document-upload [control]="lorenzFormControl"
											  [options]="lorenzFormComponentOptions"></lib-form-control-document-upload>
		}
		@case (LorenzControlTypeEnum.IMAGE_PASTE) {
			<lib-form-control-image-paste [control]="lorenzFormControl"
										  [options]="lorenzFormComponentOptions"></lib-form-control-image-paste>
		}
		@case (LorenzControlTypeEnum.OBJECT) {
			<lib-form-control-object [control]="lorenzFormControl"
									 [options]="lorenzFormComponentOptions"></lib-form-control-object>
		}
		@case (LorenzControlTypeEnum.SELECT) {
			<lib-form-control-select [control]="lorenzFormControl"
									 [options]="lorenzFormComponentOptions"></lib-form-control-select>
		}
		@case (LorenzControlTypeEnum.RADIO) {
			<lib-form-control-radio [control]="lorenzFormControl"
									[options]="lorenzFormComponentOptions"></lib-form-control-radio>
		}
		@case (LorenzControlTypeEnum.TEXT) {
			<lib-form-control-text [control]="lorenzFormControl"
								   [options]="lorenzFormComponentOptions"></lib-form-control-text>
		}
		@case (LorenzControlTypeEnum.TIME) {
			<lib-form-control-datetime [type]="'time'"
									   [control]="lorenzFormControl"
									   [options]="lorenzFormComponentOptions"></lib-form-control-datetime>
		}
		@case (LorenzControlTypeEnum.TEXTAREA) {
			<lib-form-control-textarea [control]="lorenzFormControl"
									   [options]="lorenzFormComponentOptions"></lib-form-control-textarea>
		}
		@case (LorenzControlTypeEnum.HTML) {

			@if (lorenzFormControl.payload.htmlTemplate) {
				<ng-container *ngTemplateOutlet="lorenzFormControl.payload.htmlTemplate  ?? null"></ng-container>
			}

		}
	}

}
